/* eslint-disable */
function validateEmptyRequired(value) {
  if (!value) {
    return 'Este campo é obrigatório';
  }
  return true;
}

function validateEmptyAndLength3(value) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }

  if (value.length < 3) {
    return 'Esse campo precisa ter ao menos 3 caracteres';
  }

  return true;
}

function validateEmptyAndEmail(value) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }

  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!regex.test(value)) {
    return 'E-mail invalido';
  }

  return true;
}

function validateEmptyAndStrongPassword(value) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
  if (!regex.test(value)) {
    return 'A senha informada não atende os requisitos mínimos';
  }

  return true;
}

function required(value) {
  if (!value) {
    return 'Este campo é obrigatório';
  }
  return true;
}

function minLength (value, size = 3) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }

  if (value.length < size) {
    return `Esse campo precisa ter ao menos ${size} caracteres`;
  }

  return true;
}

function email(value) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }

  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!regex.test(value)) {
    return 'E-mail inválido';
  }

  return true;
}

function strongPassword(value) {
  const required = validateEmptyRequired(value);

  if (required !== true) {
    return required;
  }
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
  if (!regex.test(value)) {
    return 'A senha informada não atende os requisitos mínimos';
  }

  return true;
}

export default {
  validateEmptyAndEmail,
  validateEmptyAndLength3,
  validateEmptyAndStrongPassword,
  validateEmptyRequired,
  required,
  minLength,
  email,
  strongPassword
};
